import { generatePath } from 'react-router-dom'
import { GridCellProps } from '@progress/kendo-react-grid'
import { TransactionKey } from 'api/Transaction/Types/Transaction'
import { Link } from 'components/Link'
import { generateClassNameForReverseType } from 'helpers/transactions'

import { GridColumn, transactionIBTransactionsColumns } from './transactionIBTransactionsColumns'

const ReferenceCell = (props: GridCellProps): JSX.Element => {
  return (
    <td
      className={generateClassNameForReverseType(props.dataItem)}
      style={{ color: 'var(--link)', textDecoration: 'underline' }}
    >
      <Link
        to={{
          pathname: generatePath('/transactions/:id', {
            id: props.dataItem.id,
          }),
        }}
      >
        {props.dataItem.referenceId}
      </Link>
    </td>
  )
}

export const transactionIBCommissionsColumns: GridColumn[] = [
  {
    title: 'Reference',
    field: TransactionKey.reference,
    cell: ReferenceCell,
    show: true,
    filter: 'text',
  },
  ...transactionIBTransactionsColumns,
]
